import React from 'react'

const ScrollControls = ({ onScrollUp, onScrollDown }) => {
  return (
    <div>
      <div onClick={onScrollUp} className="up_arrow_invisible"></div>
      <div onClick={onScrollDown} className="down_arrow_invisible"></div>
    </div>
  )
}

export default ScrollControls
